export default {
  routeDetails: {
    routeDetails: 'Detalii despre traseu',
    warnings: 'Avertismente',
    routes: 'Rute',
    route: 'Rută',
    segments: 'Segmente',
    segment: 'Segmentul',
    instructions: 'Instrucțiuni',
    instruction: 'Instrucțiune',
    name: 'Nume',
    selectRoute: 'Selectați această rută',
    selectedRoute: 'Traseu selectat',
    gotoSegment: 'Mergeți la segment',
    warningCodes: {
      1: 'Este posibil să existe restricții pe unele drumuri',
      2: 'Există autostrăzi cu taxă de-a lungul traseului',
      3: 'Există segmente sărite de-a lungul traseului. Este posibil ca duratele și accesibilitatea să nu fie corecte',
      4: 'Cel puțin o informație suplimentară solicitată, dar care nu este disponibilă',
    },
    routeOpacity: 'Opacitatea rutei',
  }
}
